import React from 'react';
import { noop } from 'src/components/base';
import { useProductContext } from '../../../product-context';

import Rating from 'src/components/rating';
import ErrorBoundary from 'src/components/error-boundary';
import { LinkToReviews } from '../LinkToReviews';
import { ProductFilters } from 'src/areas/product/components/product-filters';
import { ActionButtonsMobile } from './action-buttons';
import { OurChoice } from '../our-choice';

import { getProductMedia } from '../../utils';

import type { ProductHeaderProps } from '../../types';

import {
  CampaignBadge,
  MainSection,
  MobileHeader,
  ProductMedia,
  StyledRating,
  Title,
  TitleWrapper,
} from './styles';

export const ProductHeaderMobile: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<ProductHeaderProps>>
> = props => {
  const { currentCampaign } = props;
  const { product } = useProductContext();

  const hasNoReviews =
    product.aggregatedRatingSummary?.summary.rating.count === 0 ||
    (!product.aggregatedRatingSummary && product.userReviewSummary.count === 0);

  return (
    <MobileHeader data-test="MobileProductHeader">
      <MainSection>
        <ErrorBoundary onError={noop}>
          {product && (
            <>
              {currentCampaign ? (
                <CampaignBadge
                  colors={currentCampaign.media.colors}
                  size="large"
                />
              ) : null}
              <ProductMedia
                name={product.name}
                media={getProductMedia(product.media)}
                category={product.category}
              />
            </>
          )}
        </ErrorBoundary>
        <div>
          <TitleWrapper>
            <Title data-test="ProductTitle">{product.name}</Title>

            <ActionButtonsMobile />
          </TitleWrapper>

          <LinkToReviews>
            {product.userReviewSummary &&
            product.userReviewSummary.count !== 0 ? (
              <StyledRating>
                <Rating
                  hide={hasNoReviews}
                  rate={
                    product.aggregatedRatingSummary?.summary?.rating?.score ||
                    product.userReviewSummary.rating
                  }
                  count={
                    product.aggregatedRatingSummary?.summary?.rating?.count ||
                    product.userReviewSummary.count
                  }
                  size="medium"
                  showRate
                  showRateAs="number"
                  showCounterAs="number"
                  styleCounterAsLink
                />
              </StyledRating>
            ) : null}
          </LinkToReviews>
        </div>
      </MainSection>

      <ProductFilters />
      <OurChoice campaign={currentCampaign} />
    </MobileHeader>
  );
};
